import React from 'react';
import { Modal, Button } from 'grab-ui';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import cx from 'classnames';
import css from './ineligible-offer-modal.less';

const IneligibleOfferModal = ({
  handleClose,
  visible,
  handleSubmit,
  deliveryCount,
}) => (
  <Modal
    className={cx(css.modalContainer, css.offerModalContainer)}
    centered
    visible={visible}
    onOk={handleClose}
    footer={[
      <div className={css.footerContainer} key="buttons">
        <div key="ok" className={cx(css.btnContainer, css.btnBackContainer)}>
          <Button
            className={cx(css.keepButton, css.smallButton, css.modalButton)}
            key="keep"
            onClick={handleClose}
          >
            <span>
              {I18n.t(
                'phrase.geWebBulkUpload.express_web_bulk_upload_button_back_offers',
              )}
            </span>
          </Button>
        </div>

        <div
          key="cancel"
          className={cx(css.btnContainer, css.btnApplyContainer)}
        >
          <Button
            type="primary"
            className={cx(css.smallButton, css.modalButton, css.applyButton)}
            key="keep"
            onClick={handleSubmit}
          >
            <span>
              {I18n.t(
                'phrase.geWebBulkUpload.express_web_bulk_upload_button_apply_offer_offers',
              )}
            </span>
          </Button>
        </div>
      </div>,
    ]}
    maskStyle={{ backgroundColor: 'rgba(28, 28, 28, 0.5)' }}
  >
    <div className={css.modalContainer}>
      <div className={css.infoContainer}>
        <h3>
          {I18n.t(
            'phrase.geWebBulkUpload.express_web_bulk_upload_heading_apply_offer_to_deliveries_offers',
            {
              amountOfDeliveries: deliveryCount,
            },
          )}
        </h3>
        <div>
          <span>
            {I18n.t(
              'phrase.geWebBulkUpload.express_web_bulk_upload_body_apply_offer_most_discount_offers',
              {
                X: deliveryCount,
              },
            )}
          </span>
        </div>
      </div>
    </div>
  </Modal>
);

IneligibleOfferModal.defaultProps = {
  deliveryCount: undefined,
};

IneligibleOfferModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  deliveryCount: PropTypes.number,
};
IneligibleOfferModal.defaultProps = {};

export default IneligibleOfferModal;
